import { routes } from "@constants/routes";
import { CourseListSwiper, handleApiRequest, openExternalLink } from "@cpj-ai/panel-npm-package";
import {
  StartCourseMutation,
  StartCourseMutationVariables,
  useGetCoursesQuery,
  useStartCourseMutation,
} from "@graphql/generated";
import { Button } from "@heroui/react";
import toast from "react-hot-toast";
import "swiper/css";

const DashboardCoursesList = () => {
  const { data: courses } = useGetCoursesQuery();
  const coursesList = courses?.academy?.courses?.edges.map((item) => item?.node) || [];

  const [startCourse, { loading }] = useStartCourseMutation();

  const handleStartCourse = async (id: string) => {
    await handleApiRequest<StartCourseMutation, StartCourseMutationVariables>({
      apiFunction: startCourse,
      variables: { id },
      requiredFields: { id: "Something went wrong. Please try again." },
      componentName: "CourseList",
      actionName: "startCourse",
      fallbackErrorMessage: "Unable to start the course. Please try again.",
      extraErrorContext: {
        courseId: id,
      },
      successMessage: "Course started successfully",
      onSuccess(result) {
        if (result?.data?.academy?.startCourse?.startUrl) {
          openExternalLink({ url: result.data.academy.startCourse.startUrl });
        } else {
          toast.error("Unable to start the course. Please try again.");
        }
      },
    });
  };

  const handleSeeAll = () => {
    window.location.href = routes.college.main;
  };

  return (
    <>
      {coursesList.length > 0 && (
        <div className="mt-9">
          <div className="flex items-center mb-2 justify-between">
            <p className="text-sm lg:text-lg font-medium">Remaining Courses:</p>
            <Button
              variant="light"
              color="primary"
              className="text-sm lg:text-lg font-medium min-w-0 px-2 py-1 h-fit"
              onPress={handleSeeAll}
            >
              See all
            </Button>
          </div>
          <CourseListSwiper
            courses={coursesList}
            cardProps={{
              onClick: handleStartCourse,
              isClickable: true,
              isDisabled: loading,
            }}
          />
        </div>
      )}
    </>
  );
};
export default DashboardCoursesList;
